export const wishlistTypes = {
  DISPLAY_WISHLIST: "DISPLAY_WISHLIST",
  ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
  DELETE_FROM_WISHLIST: "DELETE_FROM_WISHLIST",
};
